export default {
  navbar:{
    index: 'Home',
    center: 'Products',
    advanced: 'Contact Us',
    solve: 'FTY',
    about: 'About Us'
  },
  prod:{
    save: 'Consumer grade product',
    dd: 'Customized product',
    fz: 'Industrial control grade products',
    xl: 'WBBGA Series Packaging'
  },
  Home:{
    ho1: 'Various products, come and choose with satisfaction',
    ho2: 'Company Introduction',
    ho3: 'Enterprise Development History',
  },
  Ourfactory: {
    name: 'Our factory',
  },
  Productcenter: {
    name: 'Product Center',
  },
  submitoBJ:{
    name: 'submit',
  },
  introduction:{
    line: 'Hangzhou XincerfarM Holding Co., Ltd.',
    line1: 'Hangzhou XincerfarM Holding Co., Ltd. was established on  2023. It is a company that focuses on the semiconductor electronic information industry and has coordinated development in multiple fields. The company adheres to the principle of "customer demand" and provides professional, efficient, and personalized services to well-known enterprises and end consumers around the world. It is committed to becoming the most trusted integrated service solution partner for customers. Currently, the company focuses on the development of the semiconductor industry, the procurement and import/export of raw material inventory and equipment, and global trade of consumer products. We provide integrated storage solutions, including NAND FLASH storage products, professional flash cards, SSDs, and NAS',
    line2: 'Canton Fair',
    line3: 'Leveraging the Global Platform of Canton Fair, Deeply Cultivating Overseas Market in Two Sessions, Building Brand Attractiveness with Domestic Production Strength and Chinese Style Aesthetics',
    line4: 'Private brand',
    line5: 'Strategic Layout in C-end Market: Dual Brands Launch a New Journey to Reshape the New Benchmark of Storage Solutions\n' +
      'In October 2024, based on its profound accumulation in serving industrial users and with the strategic vision of "bringing high-quality storage experience to a wider consumer group", the company officially embarked on a new journey of home scenario solutions. To accurately meet the needs of different customer groups, we have meticulously created and registered two private  brands, Xincerfarm and Krystaic, forming a dual-brand matrix to build differentiated competitive advantages. Among them, Xincerfarm focuses on the domestic high-end consumer market, meeting the strict storage quality requirements of high-net-worth users with customized designs and extreme performance; Krystaic targets the global overseas market, integrating localized needs with an international perspective to provide efficient storage solutions suitable for diverse scenarios.'
  },
  introduction2:{
    line: 'HangZhou SincerFar Holding Co.,Ltd',
    line1: 'HangZhou SincerFar Holding Co.,Ltd. was established on  2023. It is a company that focuses on the semiconductor electronic information industry and has coordinated development in multiple fields. The company adheres to the guidance of "customer needs" and serves major well-known enterprises and end consumers around the world with the characteristics of "professionalism, efficiency, and personalization". It is committed to becoming the most trusted integrated service solution partner for customers. At present, the company focuses on the development of the semiconductor industry, the procurement and sales of raw material inventory and equipment, as well as import and export business, and global trade of consumer products. We provide integrated storage solutions, including NAND FLASH storage products, professional flash cards, SSDs, and NAS.',
    line2: 'Brazil Exhibition',
    line3: 'Breaking Through with the Brazil Exhibition, Achieving Triple Breakthroughs in Market Expansion, Agent Landing and Brand Deep Cultivation',
    line4: 'Hong Kong Exhibition',
    line5: 'Debuting at Hong Kong Exhibition, New PSSD Product Launch Attracts Great Attention and Wins Wide Market Praise with Strong Strength'
  },
  Product:{
    pro: 'SSD',
    pro1: 'Mobile Solid State Drive',
    pro2: 'U disk',
    pro3: 'Memory Module',
    pro4: 'Private Clouds',
    pro5: 'Memory card',
  },
  footer:{
    foo:'26th Floor, Zhejiang Xinda Building, No. 25 Juye Road, Xixing Street, Binjiang District, Hangzhou City',
    foo1:'Foreign trade business',
    foo2:'Contact Number',
    foo3:'Contact Email',
    foo4:'Domestic business',
  },
  productcenter:{
    cen: 'All products',
    cen1: 'selected',
    cen2: 'Consumer grade products',
    cen3: 'Industrial grade products',
    cen4: 'Submit Intention Form',
    cen5: 'Products Details',
  },
  Ares:{
    name: 'Mars Ares',
    intro: 'MRT3500, PCIE3.0 series products, use high-quality TLC particles and graphene heat dissipation patches to enhance heat dissipation, with an instantaneous maximum read and write speed of up to 3500MB/S',
  },
  Poseidon:{
    name: 'Neptune Poseidon',
    intro: 'NET7000, PCIE4.0 series products, using high-quality TLC particles and graphene heat dissipation patches to enhance heat dissipation, with an instantaneous maximum read and write speed of 7450MB/S',
  },
  core:{
    cor:'Factory Overview',
    cor1:'In 2023, HangZhou SincerFar Holding Co.,Ltd., holding shares in Zhejiang Shenhu Technology Co., Ltd., will lead M2C and M2B trade, relying on advanced packaging and manufacturing technology in the factory to achieve nanometer level high precision in flash memory\n' +
      '                We have developed and produced breakthrough products in key areas such as Memory and Dynamic Random Access Memory (DRAM), providing core application solutions for IoT data infrastructure, smart cities, and home cloud storage.',
    cor2:'Own factory',
    cor3:'Factory scenery and operation workshop',
    cor4:'Factory Introduction',
  },
  about:{
    ab:'About Us',
    ab1:'customer Cases',
    ab2:'The company has established a deep binding cooperation with Made In China in 2023, becoming its diamond partner. During the cooperation period, it provided storage solutions to nearly 100 companies and customers, and had deep cooperation with traders from multiple Middle Eastern countries.',
    ab3:'Corporate culture',
    ab4:'The company always adheres to the development concept of "steady development and win-win cooperation", upholds the business philosophy of "sunshine, standardization, quality, and sharing", and is based on the current situation\n' +
      '            ，Focusing on the future, steadily cultivating traditional industries, while sparing no effort to expand emerging industries, especially high-tech and cutting-edge industries。',
  },
  ContactUs:{
    cont0:'About Us',
    cont:'Address: 26th Floor, Zhejiang Xinda Building, No. 25 Juye Road, Xixing Street, Binjiang District, Hangzhou City',
    cont1:'Foreign trade business',
    cont2:'Contact Number',
    cont3:'Contact Email',
    cont4:'Domestic business',
    cont5:'Contact Number',
    cont6:'Contact Email',
  },
  cg:{
    cg:'Please fill in the purchase intention form',
    cg1:'Registration Type',
    cg2:'corporate name',
    cg3:'Company address',
    cg4:'Contact Name',
    cg5:'CONTACT PHONE',
    cg6:'Contact Email',
    cg7:'submit',
  },
  Aphrodite:{
    name: 'Venus Aphrodite Sata',
    intro: 'VES500, SATA3.0 series products, using high-quality TLC particles, with an instantaneous maximum read and write speed of up to 550MB/S',
  },
  Blackhead:{
    name: 'Blackhead USB flash drive',
    intro: 'U301,USB3.0 metal material high speed transmission',
  },
  Rotate:{
    name: 'Rotating USB flash drive',
    intro: 'U320C, USB 3.2 and TYPE C dual head interface, metal material, rotating dustproof',
  },
  huoxing:{
    name: 'Mars Ares',
    intro: 'MRT3500, PCIE3.0 series products, use high-quality TLC particles and graphene heat sink paste to enhance heat dissipation, instantaneous maximum read and write speed up to 3500MB/S',
  },

  ShuixingTotate: {
    name: 'Mercury Hermes PSSD',
    intro: 'Mobile Storage, Magnetic Convenience, Global Positioning',
  },

  Hermes: {
    name: 'Mercury Hermes',
    intro: 'In Greek mythology, Mercury is known as Hermes, the god of speed. As the planet closest to the Sun, Mercury has the smallest volume and mass and often rises and sets simultaneously with the Sun. Due to its characteristics of small volume and high speed, it is used as the code name for portable PSSD products.',
  },
  haiwangxing:{
    name: 'Neptune Poseidon',
    intro: 'NET7000, PCIE4.0 series products, using high-quality TLC particles and graphene heat dissipating paste to enhance heat dissipation, instantaneous maximum read and write speed up to 7450MB/S',
  },
  jingxing:{
    name: 'Venus Aphrodite sata',
    intro: 'VES500, SATA3.0 series products, using high-quality TLC particles, instantaneous maximum read/write speed up to 550MB/S',
  },
  heitoupan:{
    name: 'Blackhead USB flash drive',
    intro: 'U301, metal, USB3.0 interface, capacity up to 256G',
  },
  xuanzhuangupan:{
    name: 'Rotating U disk',
    intro: 'Dual ports U320C, USB3.2 and TYPE C, metal, rotary dust proof',
  },
}



// WEBPACK FOOTER //
// ./src/lang/en.js